<template>
<div class="user_tab2 no-trans" v-loading="loading">
    <div class="box3_top">
        <div class="top_left">
            <div class="borders"></div>
            <div class="texts">奖励提现记录</div>
        </div>
        <div class="top_right">
            <div class="type_item" v-for="(item, index) in type_list" :key="index"
                :class="{ 'type_item_ac': item.state == types_ac }" @click="handle_type(item)">
                <div class="type_title">{{ item.title }}</div>
                <div class="type_bor"></div>
            </div>
        </div>
    </div>
    <div class="box3_bom">
        <div class="order_list">
            <el-table :data="order_list" style="width: 100%" v-if="type_show">
                <el-table-column prop="batch_number" label="受理号" v-if="types_ac == 30 || types_ac == 50|| types_ac == 70"> </el-table-column>
                <el-table-column prop="tx_sn" label="提现单号"
                    v-if="types_ac == 60  || types_ac == 10 || types_ac == 20 || types_ac == 30|| types_ac == 40"> </el-table-column>
                <el-table-column prop="money" label="申请总额"
                    v-if="types_ac == 60 || types_ac == 10 || types_ac == 20 || types_ac == 30 || types_ac == 40|| types_ac == 50|| types_ac == 70"> </el-table-column>
                <el-table-column prop="individual_income_tax" label="个税 " v-if="types_ac == 50||types_ac == 20|| types_ac == 70"> </el-table-column>
                <el-table-column prop="amount" label="实发总额" v-if="types_ac == 50||types_ac == 20|| types_ac == 70"> </el-table-column>
                <el-table-column prop="tag_time" label="发放时间" v-if="types_ac == 50"> </el-table-column>
                <el-table-column prop="created_at" label="提现时间"
                    v-if="types_ac == 60 || types_ac == 10 || types_ac == 20 || types_ac == 30|| types_ac == 40"> </el-table-column>
                <el-table-column prop="reason" label="未通过原因" v-if="types_ac == 30"> </el-table-column>
                <el-table-column prop="refuse_time" label="审核时间 " v-if="types_ac == 30"> </el-table-column>
                <el-table-column prop="title" label="状态">
                    <template slot-scope="scope">
                        <div class="teges_box">
                            <div class="teges tege_color1" v-if="types_ac == 60">待上传发票</div>
                            <div class="teges tege_color2" v-if="types_ac == 10">审核中</div>
                            <div class="teges tege_color4" v-if="types_ac == 20">已通过 </div>

                            <div class="teges tege_color3" v-if="types_ac == 30">未通过</div>
                            <div class="teges tege_color4" v-if="types_ac == 50">已发放 </div>
                            <div class="teges tege_color5" v-if="types_ac == 40">已取消</div>
                            <div class="teges tege_color5" v-if="types_ac == 70">待发放</div>
                        </div>
                    </template>
                </el-table-column>


                <el-table-column prop="title" label="操作" v-if="types_ac == 60 || types_ac == 10 ">
                    <template slot-scope="scope">
                       <div class="btn_flex">
                        <div class="btns1" @click="handle_upfp(scope.row)">上传发票</div>
                        <!-- <div class="btns1">查看发票</div> -->
                        <div class="btns1" @click="handle_qxsq(scope.row)" v-if="types_ac == 60|| types_ac == 10 ">取消申请</div>
                       </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pages_box">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pages.page" background :page-size="pages.limit" layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns" @click="handle_pages(10)">尾页</div>
        </div>
    </div>





    <el-dialog title="上传发票" :visible.sync="fp_show" :before-close="handleClose">
        <div class="dialog_box">
            <div class="form_box">
                <div class="form_titles"><span>*</span>上传发票凭证</div>
                <div class="form_inputs">
                    <div class="input_btns1" @click="handle_fp_up">
                        <img src="@/assets/img/user_info/user_jl/up1.png" alt="">
                        上传
                    </div>
                    <div class="input_text">（请上传png、jpg、pdf文件等，可以在1M内上传）</div>
                    <div class="input_file">
                        <div class="file_list" v-for="(item,index) in fp_list" :key="index">
                            <div class="file_title">{{ item.name }}</div>
                            <div class="file_clear">
                                <img src="@/assets/img/user_info/user_jl/clear.png" alt="" @click="handle_clear(index)">

                            </div>
                        </div>
                    </div>
                    <div class="form_btns">
                        <div class="btns1" @click="handle_end">提交</div>
                        <div class="btns2" @click="handle_qx">取消</div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
    <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>

</div>
</template>
<script>
import { mapState } from 'vuex'
import upload from '@/components/upload/upload.vue'


export default {
    components: {
        upload,

    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png','pdf']),
            loading: false,
            fp_show: false,
            types_ac: 60,
            type_show: true,
            type_list: [
                // 10提交待审核 20审核通过 30审核拒绝 40取消 50已发放	60待上传发票
                {
                    title: '待上传发票',
                    state: 60,
                },
                {
                    title: '待审核',
                    state: 10,
                },
                {
                    title: '已通过',
                    state: 20,
                },
                
                {
                    title: '未通过',
                    state: 30,
                },
                {
                    title: '待发放',
                    state: 70,
                },
                {
                    title: '已发放',
                    state: 50,
                },
                
                {
                    title: '已取消',
                    state: 40,
                }

            ],
            order_list: [{
                title: 123
            }],

            total: 100,
            pages: {
                page: 1,
                limit: 10,
            },
            item_row:{},
            fp_list:[],

        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
         get_list(){
            this.loading=true
            this.$api("txLog", {
                ...this.pages,
                status:this.types_ac,
                
			}, "get").then((res) => {
                this.loading = false
                console.log('提现记录',res)
                if (res.code == 1) {
                    this.order_list=res.data.list
                    this.total=res.data.count
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_type(item) {
            this.type_show = false
            this.types_ac = item.state
            let that = this
            setTimeout(() => {
                that.order_list=[]
                that.type_show = true
                that.pages.page=1
                that.get_list()

            }, 100)
        },

        handleSizeChange(e) {
            console.log('条数', e)
        },
        handleCurrentChange(e) {
            console.log('页数', e)
        },
        handle_pages(i) {
            console.log('首页尾页', i)
            this.pages.page = i
        },
        
       

        handleClose(){
            this.fp_show=false
        },
        handle_upfp(row){
            this.item_row=row
            this.fp_show=true
        },

        handle_qxsq(row){
            this.$confirm('是否取消申请?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               
                this.loading=true
                this.$api("cancelTxLog", {
                    id:row.id,
                }, "post").then((res) => {
                    this.loading = false
                    console.log('取消',res)
                if (res.code == 1) {
                    that.get_list()
                    this.$message({
                        type: 'success',
                        message: '取消成功!'
                    });
                            
                    } else {
                        alertErr(res.msg)
                    }
                });


            }).catch(() => {
                   
            });
        },
        //上传文件
        handle_fp_up(){
            this.$refs.uploads.uploadFile()
            
        },
         //上传图片
        upload_url(res_data,datas){
            this.fp_list.push(res_data)
        },
        handle_clear(index){
            this.fp_list.splice(index,1)

        },
        handle_end(){
            if(this.fp_list.length==0){
                alertErr('请上传发票')
                return
            }
            this.loading=true
            this.$api("uploadTxInvoice", {
                invoice_img:JSON.stringify(this.fp_list),
                type:this.item_row.status==10?1:2,
                id:this.item_row.id,
			}, "post").then((res) => {
                this.loading = false
                console.log('上传发票',res)
                if (res.code == 1) {
                    this.fp_show=false
                    this.fp_list=[]
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_qx(){
            this.fp_show=false
            this.fp_list=[]
        },



    },

}
</script>
<style scoped lang="less">
.user_tab2 {

    background-color: #FFFFFF;
    margin-top: 17px;

    .box3_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        border-bottom: 1px solid #DEDEDE;

        .top_left {
            display: flex;
            align-items: center;

            .borders {
                width: 4px;
                height: 22px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
            }

            .texts {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 18px;
                color: #333333;
                padding-left: 28px;
            }
        }

        .top_right {
            display: flex;
            align-items: center;
            padding-right: 58px;

            .type_item {
                height: 56px;
                margin-left: 50px;
                cursor: pointer;

                .type_title {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;
                    height: 53px;
                    // line-height: 53px;
                    padding-top: 23px;
                    padding-bottom: 9px;
                    text-align: center;

                }

                .type_bor {
                    width: 56px;
                    height: 3px;
                    border-radius: 0px 0px 0px 0px;
                    margin: auto;
                }

                &:hover {
                    .type_bor {
                        background: #377CFD;

                    }
                }
            }

            .type_item_ac {
                .type_bor {
                    background: #377CFD;

                }
            }
        }

    }

    .box3_bom {
        padding: 24px 32px;

        .order_list {
            border: 1px solid #E5E5E5;

            /deep/.el-table {
                .el-table__header-wrapper {
                    .el-table__cell {
                        background-color: hsla(219, 98%, 60%, 0.03);
                        text-align: left !important;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        padding: 0 !important;
                        height: 44px;
                    }

                    .el-table__cell:nth-child(1) {
                        padding-left: 24px !important;
                    }
                }

                .el-table__body-wrapper {
                    .el-table__row {
                        .el-table__cell {
                            text-align: left !important;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #333333;
                        }

                        .el-table__cell:nth-child(1) {
                            padding-left: 24px !important;
                        }
                    }
                }
            }



            .teges_box {
                display: flex;
                align-items: center;
                // justify-content: center;
                flex-wrap: wrap;

                .teges {
                    padding: 3px 12px;
                    border-radius: 2px 2px 2px 2px;
                    font-weight: 400;
                    font-size: 12px;

                }

                .tege_color1 {
                    background: #F2F2F2;
                    color: #666666;
                    border: 1px solid #C1C1C1;
                }

                .tege_color2 {
                    background: #E6F7FF;
                    color: #1890FF;
                    border: 1px solid #1890FF;

                }

                .tege_color3 {
                    background: #FFF1F0;
                    color: #FF4D4F;
                    border: 1px solid #FF4D4F;

                }

                .tege_color4 {
                    background: #F6FFED;
                    color: #52C41A;
                    border: 1px solid #52C41A;

                }

                .tege_color5 {
                    background: #FFFDF0;
                    color: #FF9100;
                    border: 1px solid #FFBE4D;

                }
            }
            .btn_flex{
                display: flex;
                align-items: center;
                .btns1{
                    margin-right: 14px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #377CFD;
                    cursor: pointer;
                }
            }


        }
    }

    .pages_box {
        width: 100%;
        height: 100px;
        // background-color: red;
        display: flex;
        align-items: center;
        justify-content: end;

        /deep/.el-pagination {
            .btn-prev {
                background-color: #FFFFFF;
                border: 1px solid #EEEEEE;

            }

            .el-pager {
                .number {
                    background-color: #FFFFFF;
                    border: 1px solid #EEEEEE;

                }

                .active {
                    background-color: #377CFD;
                }

                .el-icon {
                    background-color: #FFFFFF;
                }
            }

            .btn-next {
                background-color: #FFFFFF;
                border: 1px solid #EEEEEE;

            }
        }

        .btns {
            width: 40px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #EEEEEE;
            font-family: PingFang-SC-Medium, PingFang-SC-Medium;
            font-weight: normal;
            font-size: 14px;
            color: #7A7A7A;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
        }
    }

    /deep/.el-dialog__wrapper {
        .el-dialog {
            width: 580px;

            .el-dialog__header {
                background: #F7F7F7;
            }

            .el-dialog__body {
                .dialog_box {
                  display: flex;
                  justify-content: center;
                  .form_box{
                    display: flex;
                    .form_titles{
                        width: 100px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        line-height: 28px;
                        span{
                            color: #FD4C5C;
                        }
                    }
                    .form_inputs{
                        padding-left: 25px;
                        width: 350px;
                        .input_btns1{
                            width: 88px;
                            height: 28px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #377CFD;
                            cursor: pointer;
                            img{
                                width: 10px;

                            }
                        }
                        .input_text{
                            padding-top: 15px;
                            font-weight: normal;
                            font-size: 12px;
                            color: #999999;

                        }
                        .input_file{
                            padding-top: 14px;
                            .file_list{
                                display: flex;
                                align-items: center;
                                margin-bottom: 10px;
                                .file_title{
                                    // width: 100px;
                                    font-weight: normal;
                                    font-size: 14px;
                                    color: #333333;

                                }
                                .file_clear{
                                    padding-left:18px ;
                                    img{
                                        cursor: pointer;
                                        width: 12px;
                                    }
                                }
                            }
                        }
                        .form_btns{
                            display: flex;
                            align-items: center;
                            padding-top: 30px;
                            .btns1{
                                width: 76px;
                                height: 40px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px; 
                                text-align: center;
                                line-height: 40px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                                margin-right: 24px;
                            }
                            .btns2{
                                width: 76px;
                                height: 40px;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                text-align: center;
                                line-height: 40px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                            }
                        }
                    }
                  }

                   
                }

            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_tab2.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        margin-top: 16px;
    }
    .user_tab2.no-trans .box3_top {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        min-height: 44px;
    }
    .user_tab2.no-trans .box3_top .top_left {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_tab2.no-trans .box3_top .top_left .borders {
        width: 4px;
        height: 22px;
        border-radius: 3px 3px 3px 3px;
    }
    .user_tab2.no-trans .box3_top .top_left .texts {
        font-size: 18px;
        padding-left: 16px;
    }
    .user_tab2.no-trans .box3_top .top_right {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-right: 16px;
    }
    .user_tab2.no-trans .box3_top .top_right .type_item {
        height: 56px;
        margin-left: 16px;
    }
    .user_tab2.no-trans .box3_top .top_right .type_item .type_title {
        font-size: 16px;
        height: 53px;
        padding-top: 16px;
        padding-bottom: 9px;
    }
    .user_tab2.no-trans .box3_top .top_right .type_item .type_bor {
        width: 56px;
        height: 3px;
        border-radius: 0px 0px 0px 0px;
        margin: auto;
    }
    .user_tab2.no-trans .box3_bom {
        padding: 16px 16px;
    }
    .user_tab2.no-trans .box3_bom .order_list /deep/ .el-table .el-table__header-wrapper .el-table__cell {
        font-size: 14px;
        padding: 0 !important;
        height: 44px;
    }
    .user_tab2.no-trans .box3_bom .order_list /deep/ .el-table .el-table__header-wrapper .el-table__cell:nth-child(1) {
        padding-left: 16px !important;
    }
    .user_tab2.no-trans .box3_bom .order_list /deep/ .el-table .el-table__body-wrapper .el-table__row .el-table__cell {
        font-size: 16px;
    }
    .user_tab2.no-trans .box3_bom .order_list /deep/ .el-table .el-table__body-wrapper .el-table__row .el-table__cell:nth-child(1) {
        padding-left: 16px !important;
    }
    .user_tab2.no-trans .box3_bom .order_list .teges_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_tab2.no-trans .box3_bom .order_list .teges_box .teges {
        padding: 3px 12px;
        border-radius: 2px 2px 2px 2px;
        font-size: 14px;
    }
    .user_tab2.no-trans .box3_bom .order_list .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_tab2.no-trans .box3_bom .order_list .btn_flex .btns1 {
        margin-right: 14px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_tab2.no-trans .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_tab2.no-trans .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_titles {
        width: 100px;
        font-size: 14px;
        line-height: 28px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs {
        padding-left: 16px;
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .input_btns1 {
        width: 88px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 28px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .input_btns1 img {
        width: 10px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .input_text {
        padding-top: 15px;
        font-size: 14px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .input_file {
        padding-top: 14px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .input_file .file_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 10px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .input_file .file_list .file_title {
        font-size: 14px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .input_file .file_list .file_clear {
        padding-left: 16px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .input_file .file_list .file_clear img {
        width: 12px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .form_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .form_btns .btns1 {
        width: 76px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        margin-right: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_tab2.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_inputs .form_btns .btns2 {
        width: 76px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
